/**
 * Renders an error
 * @param {string} title title of the error
 * @param {string} message message describing the error
 * @returns {string}
 * @constructor
 */
function ErrorDisplayComponent(title, message) {
  return `
      <main class="sm:flex">
        <p class="text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl">Error</p>
        <div class="sm:ml-6">
          <div class="sm:border-l sm:border-gray-200 sm:pl-6">
            <h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">${title}</h1>
            <p class="mt-1 text-base text-gray-500">${message}</p>
          </div>
        </div>
      </main>
  `;
}

export default ErrorDisplayComponent;
